import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-thank-you',
  standalone: true,
  imports: [],
  templateUrl: './upgrade-thank-you.component.html',
  styleUrl: './upgrade-thank-you.component.scss'
})
export class UpgradeThankYouComponent {
  private router = inject(Router);
  onDiveIn(): void {
    this.router.navigate(['/account/logout']);
  }
}
